import NotSupportedFiles from './components/not-supported-files';
import ViewCSV from './components/view-csv';
import ViewDocx from './components/view-docx';
import ViewImages from './components/view-images';
import ViewPDFs from './components/view-pdf';

export const fileModalContentHelper = (mimeType: string, src: string) => {
  switch (mimeType) {
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.ms-excel':
    case 'application/msword':
      return <ViewDocx name="pdf" src={src} />;

    case 'image/jpeg':
    case 'image/jpg':
    case 'image/png':
    case 'image/gif':
      return <ViewImages name="image" src={src} />;

    case 'image/webp':
    case 'image/tiff':
    case 'image/avif':
    case 'image/heic':
    case 'image/heif':
      return <ViewImages name="image" src={src} />;

    case 'application/pdf':
      return <ViewPDFs name="pdf" src={src} />;

    case 'text/csv':
      return <ViewCSV name="csv" src={src} />;

    default:
      return <NotSupportedFiles src={src} />;
  }
};
